export const enum Trade {
	Buy = 'buy',
	Sell = 'sell'
}

export type TradeAction = {
	fanTokenCurrencyId?: string;
	type?: Trade;
};
